const databaseState = (state) => state.database

export const databaseSelectors = {
    table: (state) => databaseState(state).table,
    tableData: (state) => databaseState(state).tableData,
    referenceOptions: (state) => databaseState(state).referenceOptions,
    loading: (state) => databaseState(state).loading,
    referencesLoading: (state) => databaseState(state).referencesLoading,
    adding: (state) => databaseState(state).adding,
    saving: (state) => databaseState(state).saving,
    deleting: (state) => databaseState(state).deleting,
    error: (state) => databaseState(state).error,
    addError: (state) => databaseState(state).addError,
    editError: (state) => databaseState(state).editError,
}
